export default {
    topics: [
        {
            title: ' DumpArchivingStatus ',
            href: 'sm-monitoring-DumpArchivingStatus.html',
            attributes: { 'data-id': 'sm-monitoring-DumpArchivingStatus' },
            menu: { hasChildren: false },
            tocID: 'sm-monitoring-DumpArchivingStatus-d66e1948',
            topics: [],
        },
        {
            title: ' DumpCurrentInstanceState ',
            href: 'sm-monitoring-DumpCurrentInstanceState.html',
            attributes: { 'data-id': 'sm-monitoring-DumpCurrentInstanceState' },
            menu: { hasChildren: false },
            tocID: 'sm-monitoring-DumpCurrentInstanceState-d66e1956',
            topics: [],
        },
        {
            title: ' DumpInstanceState ',
            href: 'sm-monitoring-DumpInstanceState.html',
            attributes: { 'data-id': 'sm-monitoring-DumpInstanceState' },
            menu: { hasChildren: false },
            tocID: 'sm-monitoring-DumpInstanceState-d66e1964',
            topics: [],
        },
        {
            title: ' DumpInstanceStateEx ',
            href: 'sm-monitoring-DumpInstanceStateEx.html',
            attributes: { 'data-id': 'sm-monitoring-DumpInstanceStateEx' },
            menu: { hasChildren: false },
            tocID: 'sm-monitoring-DumpInstanceStateEx-d66e1972',
            topics: [],
        },
        {
            title: ' GetMissingProcesses ',
            href: 'sm-monitoring-GetMissingProcesses.html',
            attributes: { 'data-id': 'sm-monitoring-GetMissingProcesses' },
            menu: { hasChildren: false },
            tocID: 'sm-monitoring-GetMissingProcesses-d66e1980',
            topics: [],
        },
    ],
};

